module.exports = __webpack_public_path__ + "img/a1.e3e08362.jpg";